import React from "react";
import Enrolment from "../Enrolment";

const EnrolledClassAllocatedComponent = () => {
  return <Enrolment status="class-allocated" title="class-allocated" />;
};

export default EnrolledClassAllocatedComponent;
